<template>
  <of-dialog append-to-body :width="width" style="top:25%" @onCancel="cancel" :title="formTitle">
    <div slot="content">
      入会时间：
      <!-- <el-date-picker
        v-model="searchDate"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        value-format="timestamp"
      >
      </el-date-picker> -->
      <el-date-picker
        v-model="starttime"
        type="date"
        value-format="timestamp"
        style="margin-right:20px"
        placeholder="开始日期">
      </el-date-picker>
      <el-date-picker
        v-model="endtime"
        type="date"
        value-format="timestamp"
        placeholder="结束日期">
      </el-date-picker>
      <el-button
        size="small"
        style="margin-left:10px"
        type="danger"
        @click="confirm"
        >确定</el-button
      >
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  components: {
    OfDialog
  },
  data() {
    return {
      width: "45%",
      searchDate: [],
      starttime: '',
      endtime: '',
      formTitle:"导出会员信息到Excel文件"
    };
  },
  methods: {
    //取消
    cancel() {
      this.$emit("exportCallBack", null);
    },
    confirm() {
      let starttime = this.starttime / 1000;
      let endtime = this.endtime / 1000;
      // const request = {
      //   starttime:starttime,
      //   endtime:endtime
      // }
      // api.exportMember(request).then(res => {
      //   debugger
      // })
      saveAs(
        "/api/PersonalMember/QueryToExcel?starttime=" +starttime+"&endtime="+endtime,
        "会员信息表.xls"
      )
      
    }
  }
};
</script>

<style scoped>
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--default {
  display: none;
}
.el-date-editor >>> .el-range-separator .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__icon {
   display: none;
}
</style>